module.exports = __webpack_public_path__ + "static/media/32_CALCINHA_COM_BABADO_LISA_DE_AMARRAR_FINA_EMPINA_BUMBUM_02.6a3a6618.jpg";